
import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import Comments from './comments.vue';

import { getDateDiff } from './../../nmb/util';

@Component({
  components: { Comments }
})
export default class NoticeDetail extends Vue {
  userIcon: string = '';
  comments: string = '';
  newsId: string = '';
  isHoverAndPraised: boolean = false; // 是否已点赞且hover状态
  isReload: boolean = false; // 评论 | 删除后重新加载数据
  getDateDiff: Function = getDateDiff;
  toolPosition: { [key: string]: any } = {
    top: '140px',
    right: (document.body.clientWidth - 1200) / 2 - 50 + 'px'
  };

  @Getter noticeDetail: { [key: string]: any };

  @Action getNoticeDetailById: (params: object) => void;
  @Action praiseNotice: (params: object) => void;
  @Action cancelPraiseNotice: (params: object) => void;
  @Action updateNoticeView: (params: object) => void;

  mounted() {
    const { id } = this.$route.params;
    this.newsId = id;
    this.isReload = false;
    (this.updateNoticeView({
      newsId: this.newsId
    }) as any).then(() => {
      this.getNoticeDetailById({
        newsId: this.newsId
      });
    });

    const user = localStorage.logonUser;

    if (!user) return false;
    this.userIcon = JSON.parse(user).UserIcon;

    window.addEventListener('scroll', this.handleScroll, true);
    window.addEventListener('resize', this.handleResize, true);
  }

  get unescapeContent(): any {
    const { Content } = this.noticeDetail.info;

    return (
      Content &&
      Content.replace(Content ? /&(?!#?\w+;)/g : /&/g, '&amp;')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(
          /src="\/EKP\/Upload/g,
          'src="http://ekp-new.mingyuanyun.com/EKP/Upload'
        )
    );
  }

  handleResize() {
    const width = document.body.clientWidth;
    this.toolPosition.right = (width - 1200) / 2 - 50 + 'px'; // 48为tool宽度
  }

  @Watch('$route.params.id')
  handleChangeRoute(val: string, oldVal: string) {
    (this.updateNoticeView({
      newsId: val
    }) as any).then(() => {
      this.getNoticeDetailById({
        newsId: val
      });
    });
  }

  handleScroll(e: any) {
    const scrollObj = document.getElementsByClassName('layout-box')[0]; // 滚动区域
    const scrollTop = scrollObj.scrollTop; // div 到头部的距离
    if (scrollTop > 74) {
      this.toolPosition.top = '74px';
    } else {
      this.toolPosition.top = '140px';
    }
  }

  changeIsReload() {
    this.isReload = true;
  }

  praiseNoticeFn() {
    const { IsPraised } = this.noticeDetail.info;
    const params = { newsId: this.newsId };
    if (IsPraised) {
      this.cancelPraiseNotice(params);
    } else {
      this.praiseNotice(params);
    }
  }

  switchPage(type: string) {
    const { PreItem, NextItem } = this.noticeDetail.info;
    const newsId = type === 'pre' ? PreItem : NextItem;
    newsId && this.$router.push({ path: `/home/noticeDetail/${newsId}` });
  }

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}
